<button class="btn btn-sm" [ngClass]="cssClass" (click)="onClick($event)" type="button" [disabled]="isDisabled">
    <span *ngIf="isBusy" class="fas fa-circle-notch fa-spin mr-2"></span>
    <span *ngIf="!isBusy && iconClass" class="mr-2" [ngClass]="iconClass"></span>{{title}}
</button>